import toSnakeCase from 'to-snake-case'

import { APP_VERSION } from 'app-constants'

export default (event: string) => ({
  app_version: APP_VERSION,
  event_text: event,
  event: toSnakeCase(event),
})
